import { toast } from "@kyan/ui";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useEffect, useRef } from "react";

import { useRedeemReferral } from "#/services/referrals/hooks/useRedeemReferral";

import { useReferralCode } from "../app/referralCode/referralCode";
import { useAccount } from "./account/account";

export const ReferralUpdater = () => {
  const router = useRouter();
  const pathname = usePathname();
  const { account } = useAccount();
  const searchParams = useSearchParams();
  const attemptedKey = useRef<string | null>(null);
  const { referralCode, setReferralCode } = useReferralCode();

  const { mutate: redeemReferral } = useRedeemReferral({
    onSuccess: () => {
      const params = new URLSearchParams(searchParams.toString());
      params.delete("referral");
      router.replace(params.size ? `${pathname}?${params}` : pathname);

      toast.success({
        title: "Referral applied",
        description: "Referral confirmed!",
      });
      setReferralCode("");
    },
    onError: (error) => {
      toast.error({ title: "Referral validation", description: error.message });
      setReferralCode("");
    },
  });

  const code = searchParams.get("referral");

  useEffect(() => {
    if (code) {
      // if code is present, store in device. We will attempt to redeem once account is present (Even if user explores app by changing pages).
      setReferralCode(code);
    }
  }, [code, setReferralCode]);

  useEffect(() => {
    if (!referralCode || !account) return;

    const key = `${account}:${referralCode}`;
    if (attemptedKey.current === key) return;

    attemptedKey.current = key;
    redeemReferral({ code: referralCode.trim() });
  }, [referralCode, account, redeemReferral]);

  return null;
};
